const parseStringTags = (text) => {
  const parts = [];

  // Matches <b>...</b> or <i>...</i>
  const regex = /<(b|i|u)>(.*?)<\/\1>/g;

  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const before = text.slice(lastIndex, match.index);
    if (before) parts.push(before); 

    const tag = match[1];
    const content = match[2];

    if (tag === "b") {
      parts.push(<strong key={parts.length}>{content}</strong>);
    } else if (tag === "i") {
      parts.push(<em key={parts.length}>{content}</em>);
    } else if (tag === "u") {
      parts.push(<u key={parts.length}>{content}</u>);
    }

    lastIndex = regex.lastIndex;
  }

  // Add remaining text
  const after = text.slice(lastIndex);
  if (after) parts.push(after);

  return <>{parts}</>;
}

export { parseStringTags }